import { render, staticRenderFns } from "./indicadores.vue?vue&type=template&id=73684f26&"
import script from "./indicadores.vue?vue&type=script&lang=js&"
export * from "./indicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73684f26')) {
      api.createRecord('73684f26', component.options)
    } else {
      api.reload('73684f26', component.options)
    }
    module.hot.accept("./indicadores.vue?vue&type=template&id=73684f26&", function () {
      api.rerender('73684f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/indicadores.vue"
export default component.exports